import { Component } from '@angular/core';

@Component({
  selector: 'app-elastomer',
  templateUrl: './elastomer.component.html',
  styleUrls: ['./elastomer.component.scss']
})
export class ElastomerComponent {
  advanceMoullding:any[] = [
    {
      title: 'Rubber Extrusion​​',
      img: 'assets/images/capability/white/rubber_extrusion.jpg',
    },
    {
      title: 'Cryogenic Deflashing​',
      img: 'assets/images/capability/white/cryogenic_deflashing.jpg',
    },
    {
      title: 'Metal To Rubber Parts',
      img: 'assets/images/capability/white/metal_to_rubber_parts.jpg',
    },
    {
      title: 'Elastomer Calendering​',
      img: 'assets/images/capability/white/Elastomer_Calendering.jpg',
    },
    {
      title: 'Elastomer Moulding',
      img: 'assets/images/capability/white/Elastomer_Moulding.jpg',
    },
    {
      title: 'Plastic To Rubber Bonding​',
      img: 'assets/images/capability/white/Plastic_To_Rubber.jpg',
    }
  ]
  produtData:any[] = [
    {
      title: 'Rubber Extrusion',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Elastomer Moulding​​',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Cryogenic Deflashing​',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Metal to Rubber Parts​​​',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Plastic to Rubber Bonding',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Elastomer Calendering​​',
      img: 'assets/images/placeholder.jpg',
    }
  ]  
  materialExpertise:any[] = [
    { 'item': 'Natural Rubber (NR)'},
    { 'item': 'Epi Chloro Hydrin (ECO)'},
    { 'item': 'Ethylene Propylene Diene Monomer (EPDM)'},
    { 'item': 'Styrene Butadiene Rubber (SBR)'},
    { 'item': 'Nitrile Butadiene Rubber (NBR)'},
    { 'item': 'Fluoroelastomer (FKM)'},
    { 'item': 'Hydrogenated Nitrile Butadiene Rubber (HNBR)'},
    { 'item': 'Acrylic Rubber/Ethylene Acrylate Rubber'},
    { 'item': 'Silicone Rubber (Si)'},
    { 'item': 'Chloroprene Rubber (Cr)'}
  ]
  advancemoduldingtechniques:any[] = [
    { 'item': 'Rubber Extrusion'},
    { 'item': 'Elastomer Moulding'},
    { 'item': 'Cryogenic Deflashing'},
    { 'item': 'Metal to Rubber Parts'},
    { 'item': 'Plastic to Rubber Bonding'},
    { 'item': 'Elastomer Calendering'}
  ]
  manufacturingCapabilities:any[] = [
     { 'item':'Fully automated Rubber Mixing plant'},
     { 'item':'Automatic Bonding Plant.'},
     { 'item':'Injection, Transfer & Compression moulding presses'},
     { 'item':'Plastic Injection Moulding Machines'},
     { 'item':'Extrusion Plant'},
     { 'item':'Autoclave for hoses'}
  ]
}
